import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

export default function Placeholder({ title }) {
  useSEO({ title: `${title} | Wexoz`, noindex: true });
  return (
    <section className="section wrap min-h-[70vh] pt-40" data-testid="placeholder-page">
      <div className="eyebrow">Wexoz</div>
      <h1 className="mt-4 text-4xl font-semibold sm:text-5xl">{title}</h1>
      <p className="mt-6 max-w-xl text-slate-400">This page is being built. Return to the homepage or talk to an expert.</p>
      <Link to="/" className="btn-ghost mt-10">Back to Home</Link>
    </section>
  );
}
